import React from "react";
import { StyleSheet, Text } from "react-native";
import MaterialCommunityIcons from "@expo/vector-icons/MaterialCommunityIcons";
import { router } from "expo-router";
import { Image } from "expo-image";

import UnlockUsersBaseCard from "../../Base/UnlockUsersBaseCard";

import { ProfileCompletionScore } from "@/utils/unlockingStage";
import { UserImageMedia } from "@/schemas/user/image";

type Props = {
  backgroundPhoto: UserImageMedia | null;
  onAction: () => void;
};

function UnlockUsersBackgroundPhotoCard({
  backgroundPhoto,
  onAction,
}: Props): React.JSX.Element {
  return (
    <UnlockUsersBaseCard
      iconComponent={
        backgroundPhoto ? (
          <Image
            key={backgroundPhoto.id}
            source={{ uri: backgroundPhoto.attributes.previewUrl }}
            style={styles.image}
            contentFit="cover"
            cachePolicy="memory-disk"
          />
        ) : (
          <MaterialCommunityIcons name="panorama" size={36} color="#3b5998" />
        )
      }
      title="Profile Cover Photo"
      description="Add a cover photo to your profile"
      totalScore={ProfileCompletionScore.BACKGROUND_PHOTO}
      statusComponent={
        <Text>{backgroundPhoto ? "Completed" : "Not Completed"}</Text>
      }
      isCompleted={backgroundPhoto ? true : false}
      onPressActionButton={() => {
        onAction();
        router.push("/(main)/account/home");
      }}
    />
  );
}

const styles = StyleSheet.create({
  image: {
    width: 36,
    height: 36,
    borderRadius: 6,
  },
});

export default UnlockUsersBackgroundPhotoCard;
